<div *ngIf="timelineActive === true && cardDireito.acoes.length > 0">
    <div class="sos">
        <a (click)="isSos = !isSos" class="bar">
            <span class="icon"></span>
            <h3>SOS</h3>
            <span class="subtitle"> Pendências impedindo conclusão da análise</span>
        </a>
        <div *ngIf="isSos && isRespondeSos()">
            <div class="col-xs-12">
                <div class="form-group">
                    <app-parecer-sos [cardDireito]="cardDireito"></app-parecer-sos>
                    <app-observacao [acoes]="cardDireito.acoes" [idFicha]="idFicha"></app-observacao>
                    <app-avalista [acoes]="cardDireito.acoes" [idFicha]="idFicha" [cpfCliente]="cliente.cpf"></app-avalista>
                    <app-documentos *ngIf="hasDocumentos()" [acoes]="cardDireito.acoes" [idFicha]="idFicha" [cliente]="cliente"></app-documentos>

                    <div class="sos-content">
                        <button class="btn btn-border-orange" title="Enviar SOS" (click)="sendSos()">Responder SOS</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-modal-loader #modalLoader></app-modal-loader>

<app-modal-message #modalMessage title="Atenção!" [hideClose]="true" message="Esta ficha foi recusada após expiração do prazo de atendimento da SOS!"></app-modal-message>